import React, { Component } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setPdfEditorObject } from "../../../redux/actions/scheduleReport/scheduleReport";
import { useState } from "react";
import useDebounce from "../../layout/WelcomePage/Worksheets/useDebounce";

const CkEditorPulgin = ({ note }) => {
  const dispatch = useDispatch();
  const [ckEditorText, setCKEditorText] = useState(note || null);
  const [ckEditorTouch, setCKEditorTouch] = useState(false);
  const debouncedEditorText = useDebounce(ckEditorText, 500);
  const fontSizeConfig = {
    options: [9, 10, 11, 12, "default", 14, 15],
    supportAllValues: true,
  };
  const editorConfiguration = {
    fontSize: {
      items: [9, 10, 11, 12, "default", 14, 15],
      supportAllValues: true,
    },
    toolbar: [
      "bold",
      "italic",
      "link",
      "|",
      "fontSize",
      "|",
      "bulletedList",
      "numberedList",
      "undo",
      "redo",
    ],
    link: {
      defaultProtocol: "http://",
      decorators: {
        addTargetToExternalLinks: {
          mode: "automatic",
          callback: (url) => {
            return /^(https?:)?\/\//.test(url);
          },
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer",
          },
        },
      },
    },
  };
  const pdfEditorObj = useSelector(
    (state) => state.scheduleReport.pdfEditorObj
  );

  const handleOnChange = (event, editor) => {
    const data = editor.getData();
    setCKEditorText(data);
    setCKEditorTouch(true);
  };
  useEffect(() => {
    if (ckEditorTouch) {
      dispatch(
        setPdfEditorObject({
          // paneIndex: pdfEditorObj?.paneIndex,
          // panes: pdfEditorObj?.panes,
          sectionIndex: pdfEditorObj?.sectionIndex,
          widgetIndex: pdfEditorObj?.widgetIndex,
          widgetId: pdfEditorObj?.widgetId,
          editorValue: ckEditorText,
        })
      );
    }
  }, [debouncedEditorText]);
  return (
    <>
      <CKEditor
        editor={ClassicEditor}
        config={editorConfiguration}
        data={
          pdfEditorObj?.editorValue
            ? pdfEditorObj?.editorValue
            : note
            ? note
            : ""
        }
        onReady={(editor) => {
          // You can store the "editor" and use when it is needed.
        }}
        onChange={(event, editor) => handleOnChange(event, editor)}
        onBlur={(event, editor) => {
          //console.log("Blur.", editor);
        }}
        onFocus={(event, editor) => {
          //console.log("Focus.", editor);
        }}
      />
    </>
  );
};

export default CkEditorPulgin;
